import ACTS from '../constants';

const defaultState = {
    isLoaded: false,
    isComplete: false,
    slipDetail: null,
    slipDetailMethod: null,
    transCateList: [],
    methodCateList: {}
}

export default (state = defaultState, action) => {
    switch(action.type){
        case ACTS.SEARCH_DATA:
        return {
            ...state,
            search: {...state.search, ...action.search}
        }

        case ACTS.LOAD_SLIP_LIST:
            return {
                ...state,
                slipList: action.payload[0].list,
                slipListCnt: action.payload[1].data,
                isLoaded: true,
                isComplete: false,
                isJobType: "",
                isOpenTopDelete: false,
                isRunTopDelete: false
            }            
        case ACTS.LOAD_SLIP:
            return {
                ...state,
                slipDetail: action.payload.data
            }
        case ACTS.LOAD_SLIP_REMAIN_LIST:
            return {
                ...state,
                slipRemainList: action.payload.list
            }

        case ACTS.LOAD_SCRAP:
            return {
                ...state,
                slipDetail: action.payload.data
            }
        case ACTS.LOAD_SLIP_METHOD:
            return {
                ...state,
                slipDetailMethod: action.payload.list
            }
        case ACTS.SAVE_SLIP:
            return {
                ...state,
                isComplete: action.payload.result,
                isJobType: action.type
            }
        case ACTS.SAVE_SLIP_SCRAP:
            return {
                ...state,
                isComplete: action.payload.result,
                isJobType: action.type
            }
        case ACTS.DELETE_SLIP:
            return {
                ...state,
                isComplete: action.payload.result,
                isJobType: action.type
            }
        case ACTS.SAVE_SLIP_REMAIN:
            return {
                ...state,
                isComplete: action.payload.result,
                isJobType: action.type
            }
        case ACTS.INIT_SLIP_STATUS:
            return {
                ...state,
                isComplete: false,
                isJobType: "",
                isRunTopDelete: false
            }
            
        case ACTS.UNLOAD_SLIP:
            return {
                ...state,
                slipDetail: null,
                slipDetailMethod: null,
                transCateList: []
            }
            
        case ACTS.UNLOAD_SLIP_REMAIN:
            return {
                ...state,
                slipRemainList: null
            }

        case ACTS.GET_TRANS_CATE_LIST:
            return {
                ...state,
                transCateList: action.payload.list,
            }
            
        case ACTS.GET_METHOD_LIST:            
            return {
                ...state,
                methodCateList: { 
                    bank: action.payload[0].list,
                    card: action.payload[1].list,
                    check: typeof action.payload[2] === "undefined" ? [] : action.payload[2].list
                }
            }

        case ACTS.OPEN_TOP_DELETE:
            return {
                ...state,
                isOpenTopDelete: action.status,
                isRunTopDelete: false,
                isJobType: "",
            };

        case ACTS.RUN_TOP_DELETE:
            return {
                ...state,
                isRunTopDelete: true
            };
        case ACTS.LOAD_SLIP_REMAIN_DETAIL:
            return {
                ...state,
                slipRemainDetail: action.payload.list
            }
        case ACTS.UNLOAD_SLIP_MAIN:
            return {}

        case ACTS.LOAD_SLIP_PHOTO:
            return {
                ...state, 
                receiptImg: action.payload
            }

        default:
            return { ...state };
    }
}


// WEBPACK FOOTER //
// ./src/reducers/slip.js